// Take an array of objects, return a single object grouped by key
export const groupByKey = (objectList, key) => {
  return objectList.reduce((acc, curr) => {
    if (!acc[curr[key]]) {
      return {
        ...acc,
        [curr[key]]: [curr],
      };
    } else {
      return {
        ...acc,
        [curr[key]]: [...acc[curr[key]], curr],
      };
    }
  }, {});
};



// WEBPACK FOOTER //
// ./src/helpers/group-by-key.js